import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import {
  Header,
  HeaderItem,
  Detail,
  Cogs,
  Expense,
  Rebill,
} from './Dialog';

import { startAddReceipt, startEditReceipt } from '../../../store/actions/receipts';

const styles = theme => ({
  root: {
    backgroundColor: 'green',
    padding: '0px 0px 0px 0px',
    margin: '0px',
  },
  test: {
    backgroundColor: 'blue',
  }
});

class ReceiptDialog extends Component {
  constructor(props) {
    super(props);
    const { receiptData } = props;

    if (receiptData === undefined) {
      this.state = {
        receipt: {
          type: undefined,
          date: (new Date()).getTime(),
          tax: 0,
          total: 0,
          notes: "",
          markupPercent: 0,
          charged: 0,
        },
      };
    } else {
      this.state = {
        receipt: {...receiptData}
      };
    }

  }

  handleChange (propertyName, value) {
    this.setState(function(prevState, props){
       return {
         receipt: {
           ...prevState.receipt,
           [propertyName]: value,
         }
       }
    });
  }

  render() {
    const { classes, show, type, handleClose, startAddReceipt, startEditReceipt } = this.props;
    const { receipt } = this.state;
    return(
      <div>
        <Dialog
          classes={{paper: classes.paper}}
          maxWidth="md"
          open={show}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogContent className={classes.test} >
            <Header>
              <HeaderItem
                label="Rebill"
                description="Are you going to rebill or sell your client this item, hopefully with a markup? Then choose to 'Rebill' the receipt."
                action={() => this.handleChange("type", "rebill")} />
              <HeaderItem
                label="Cost of Goods Sold"
                description="Is this receipt a direct cost against on of your jobs? By choosing COGS (Cost of Goods Sold), you can track the costs and thus profit off of the job. It will also be used to tax write-offs as well."
                action={() => this.handleChange("type", "cogs")} />
              <HeaderItem
                label="Company Expense"
                description="If this receipt doesn't relate directly to a job, nor sold to client, then it can simply be used for tax write-off. You'll be so thankful at 'year-end' when your accountant asks for all your receipts!"
                action={() => this.handleChange("type", "expense")} />
            </Header>
            <Detail receipt={receipt} handleChange={this.handleChange.bind(this)}>
              {receipt.type === "rebill" &&
                <Rebill receipt={receipt} handleChange={this.handleChange.bind(this)}/>
              }
              {receipt.type === "cogs" &&
                <Cogs receipt={receipt} handleChange={this.handleChange.bind(this)}/>
              }
              {receipt.type === "expense" &&
                <Expense receipt={receipt} handleChange={this.handleChange.bind(this)}/>
              }
            </Detail>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button
              disabled={receipt.type === undefined ? true : false}
              onClick={() => {
                if (type === "add") {
                  startAddReceipt(receipt)
                    .then(() => handleClose())
                } else {
                  const { id, ...updates } = receipt;
                  startEditReceipt(id, updates)
                    .then(() => handleClose())
                }
              }}
              color="primary">
              {type === "add" ? "Add" : "Done"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startAddReceipt: (receiptData) => dispatch(startAddReceipt(receiptData)),
  startEditReceipt: (id, updates) => dispatch(startEditReceipt(id, updates)),
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(ReceiptDialog);
//export default connect(null, mapDispatchToProps)(ReceiptDialog);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/ReceiptDialog.jsx